function resetSubmenu () {
  const mobileMenu = document.querySelector(".mobile-nav-drawer");
  const closeButtons = [mobileMenu.querySelector(".btn-close"), document.querySelector(".overlay.site-overlay")]

  closeButtons.forEach(button => {
    button.addEventListener("click", () => {
      const l3Item = document.querySelector(".submenu-item-n3.show");

      if (l3Item != null) {
        const item = l3Item.querySelector("a");
        item.click();
      }

      const l2Items = document.querySelectorAll(".megamenu-icon");

      l2Items.forEach(element => {
        if (!element.classList.contains("collapsed")) {
          element.click();
        }
      });
    })
  });

}

function hiddeL2Items (parent) {
  const listContainer = parent.closest("#list-items");
  const l2Items = listContainer.querySelectorAll(".n2-list-items > li");
  const l1Container = parent.closest(".card.border-0");
  const l1Item = l1Container.querySelector(".card-heading");

  l2Items.forEach(item => {
    item.classList.toggle("d-none");
  });

  l1Item.classList.toggle("d-none");
  parent.classList.toggle("d-none");
}

function subHeaderL3 () {
  const l3Items = document.querySelectorAll(".submenu-item-n3");

  l3Items.forEach(l3Item => {
    const item = l3Item.querySelector("a");
    item.addEventListener("click", (e)=> {
      const l3List = l3Item.querySelector(".n3-list-items");
      l3Item.classList.toggle("show");
      l3List.classList.toggle("show");

      hiddeL2Items(l3Item);
    })
  });
}

function subHeaderL2 () {
  const items = document.querySelectorAll(".megamenu-icon");

  items.forEach(item => {
    item.addEventListener("click", ()=> {
      if (item.ariaExpanded === "true") {
        items.forEach(element => {
          const parent = element.closest(".card-heading");
          parent.classList.remove("d-none");
        });
      } else if (item.ariaExpanded === null) {
        return;
      } else {
        items.forEach(element => {
          const parent = element.closest(".card-heading");
          parent.classList.add("d-none");
        });
        const parent = item.closest(".card-heading");
        parent.classList.remove("d-none");
      }

      subHeaderL3();
    })
  });
}


setTimeout(() => {
  subHeaderL2();
  resetSubmenu();
}, 300);